import {Align} from "../class/align";

export default class Bullet {
    constructor(scene, group) {
        this.scene = scene;
        this.groupBullet = group;
        this.character = scene.character;
    }

    createBullet() {
        let x;
        if (this.character.flipX) {
            x = this.character.x - 50;
        } else {
            x = this.character.x + 50;
        }
        let y = this.character.y;
        this.bullet = this.scene.physics.add.sprite(this.character.x, y, 'hidden');
        this.bullet.setVisible(false);
        let moveTo = this.scene.plugins.get('rexMoveTo').add(this.bullet, {
            speed: 600,
            rotateToTarget: true
        });
        Align.scaleToGameW(this.bullet, .1);
        this.groupBullet.add(this.bullet);
        moveTo.moveTo(x, y)
        moveTo.on('complete', (bullet, moveTo) => {
            this.tick(bullet)
        });
    }

    tick(bullet) {
        this.groupBullet.remove(bullet, true, true)
    }
}
